export default "__VITE_ASSET__CXctT1Qo__"